import React, { useContext, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from 'ui-components/components/button';
import { ProductDetailsContext } from '../../context';
import { LoadingIndicator } from 'ui-components/components/loading-indicator';
import { messages } from './messages';
import classnames from 'clsx';
import style from '../../style.module.css';
import generalStyle from './style.module.css';

export const SaveInPlace = () => {
  const { onSaveClicked, isSaveInPlaceLoading, setIsSaveInPlaceLoading, productName, productSku } = useContext(ProductDetailsContext);
  const isDisabled = productName?.length === 0 || productSku?.length === 0;

  const saveAndSetLoading = useCallback(() => {
    const reuseNewProductModal = true;
    setIsSaveInPlaceLoading(true);
    onSaveClicked(reuseNewProductModal);
  }, [onSaveClicked, setIsSaveInPlaceLoading]);
  return (
    <div className={generalStyle['save-in-place']}>
      <div className={classnames(style['shipping-defaults-header-text'], generalStyle['variants-title'])}>
        <FormattedMessage {...messages.productVariantsTitle} />
      </div>
      {isSaveInPlaceLoading && <LoadingIndicator className={generalStyle['sip-loading']} />}
      {!isSaveInPlaceLoading && (
        <div className={generalStyle['sip-content']}>
          <div className={generalStyle['sip-message']}>
            <FormattedMessage {...messages.productDetailsSaveInPlaceMessage} />
          </div>
          <Button disabled={isDisabled} onClick={saveAndSetLoading} theme='primary'>
            <FormattedMessage {...messages.productDetailsSaveInPlaceButton} />
          </Button>
        </div>
      )}
    </div>
  );
};
